import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { CategoryReadDto } from '../types';
import { ClassifierUrl } from './ClassifierUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { keepStaleInMinutes } from '../../common/queryClient/utils';

interface AllClassifierCategoriesBaseQueryParams {
  classifierCode: string;
}

export type AllClassifierCategoriesQueryParams =
  // Get all categories, category groups and combined groups without any specifity
  | AllClassifierCategoriesBaseQueryParams
  // Get all categories (excluding category groups and combined groups)
  | {
      categoryType: 'category';
      categoryGroupOrCombinedGroupCode?: never;
      levelNumber?: never;
    }
  // Get all categories in a specific category group or combined group
  | {
      categoryType?: never;
      categoryGroupOrCombinedGroupCode: string;
      levelNumber?: never;
    }
  // Get all categories on a specific level number
  | {
      categoryType?: never;
      categoryGroupOrCombinedGroupCode?: never;
      levelNumber?: number;
    };

const getAllClassifierCategories = (
  params: AllClassifierCategoriesQueryParams
) =>
  apiClient
    .get<CategoryReadDto[]>(
      expand(ClassifierUrl.ALL_CLASSIFIER_CATEGORIES, params)
    )
    .then((response) => response.data);

export const useAllClassifierCategoriesQuery = createApiQueryHook(
  ['classifier-categories'],
  getAllClassifierCategories,
  keepStaleInMinutes(5)
);
